import React, { useState } from "react";

import { rbac } from "../index";
import t from "../../../helpers/t";
import { Biscuit } from "../../../../utils";
import { taskActions } from "inbooma-api"; // necessary to communicate with inbooma-react api

const CommentList = (props) => {
  const [newComment, setNewComment] = useState({
    // placeholder for new comment
    comment: "",
    user_id: Biscuit.get("user.id"),
  });

  const onChangeComment = (e) => {
    setNewComment({
      ...newComment,
      comment: e.target.value,
    });
    props.setUnsafedComment({
      ...newComment,
      comment: e.target.value,
    });
  };

  const isLeftOrRight = (index) => {
    let isLeft = false;
    let realIndex = props.comments.length - 1 - index; // get the right index for original (none mirrored) array

    if (index >= props.comments.length || index < 0) return "";

    for (var i = props.comments.length - 1; i > realIndex; i--) {
      // toggle isLeft if user has changed
      if (props.comments[i].user_id != props.comments[i - 1].user_id) {
        isLeft = !isLeft;
      }
    }

    return isLeft ? "left" : "right";
  };

  const addCommentToTask = () => {
    props.setUnsafedComment(null);
    if (newComment.comment.length > 0) {
      props.addComment({ ...newComment });
      newComment.comment = ""; // reset new comment object, to-do: only reset on success
    }
  };

  return (
    <>
      <div className="inb-form-group column medium-12 small-12">
        <hr />
      </div>
      <div className="inb-comment-container inb-form-group column medium-12 small-12">
        {typeof props.comments !== "undefined" && typeof props.comments.length !== "undefined" && (
          <div>
            <span style={{ marginBottom: "10px" }}>{t("comments")}</span>
            <button
              type="button"
              className="inb-round-btn hollow round float-right"
              onClick={addCommentToTask}
              style={{ marginTop: "38px", marginRight: "6px" }}
            >
              <div
                className="inb-icon inb-fi-save"
                style={{ width: "16px", height: "16px", marginLeft: "11px" }}
              >
                {" "}
              </div>
            </button>
            <textarea
              className="left"
              style={{
                marginTop: "10px",
                marginBottom: "1px",
                backgroundColor: "#f9f9f9",
                width: "90%",
                resize: "vertical",
              }}
              value={newComment.comment}
              onChange={onChangeComment}
            ></textarea>
            <p className="left" style={{ marginBottom: "20px" }}>
              {props.getUserNameById(
                Biscuit.get("user.id"),
                false,
                props.userQueue,
                props.setUserQueue,
                props.extraUsers,
              )}
            </p>
            {[...props.comments].reverse().map((comment, index) => {
              return (
                <>
                  <div className={"inb-form-comment " + isLeftOrRight(index)} key={comment.id}>
                    {comment.comment}
                  </div>
                  <p className={isLeftOrRight(index)}>
                    {props.getUserNameById(
                      comment.user_id,
                      false,
                      props.userQueue,
                      props.setUserQueue,
                      props.extraUsers,
                    )}{" "}
                    {comment.created}
                  </p>
                </>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default CommentList;
